import { render, staticRenderFns } from "./BookingGuests.vue?vue&type=template&id=af355872&scoped=true&"
import script from "./BookingGuests.vue?vue&type=script&lang=js&"
export * from "./BookingGuests.vue?vue&type=script&lang=js&"
import style0 from "./BookingGuests.vue?vue&type=style&index=0&id=af355872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af355872",
  null
  
)

export default component.exports